import { Grid, Tab, Tabs, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import SuperAdminDashboardService from "../../api/Dashboard/SuperAdminDashboard/SuperAdminDashboardService";
import SubscriptionCard, { Plan } from "./SubscriptionCard";
import SubscriptionLineGraph from "./LineGraph/SubscriptionLineGraph";
import LegendToggleIcon from "@mui/icons-material/LegendToggle";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import SubscriptionPlanGraph from "./PlanGraph/SubscriptionPlanGraph";
import SubscriptionBarChart from "./PlanGraph/SubscriptionPlanGraph";

type SubscriptionData = {
  planName: string;
  activeUser: number;
  requestedUser: number;
};

const SuperAdminDashBoard = () => {
  const [subscriptionDetails, setSubscriptionDetails] = useState<Plan[]>([]);
  const [activeTab, setActiveTab] = useState<number>(0); // Default first tab active

  const fetchSubscriptionDetails = async () => {
    try {
      const res = await SuperAdminDashboardService();
      if (res.status === "success") {
        setSubscriptionDetails(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchSubscriptionDetails();
  }, []);


  console.log(subscriptionDetails)

  const transformedData: SubscriptionData[] = subscriptionDetails.map((plan) => ({
    planName: plan.planName, // Ensure Plan has a planName field
    activeUser: plan.activeUser || 0, // Default to 0 if undefined
    requestedUser: Number(plan.requestedUser) || 0, // Default to 0 if undefined
  }));
  

  return (
    <div className="h-[87vh] flex flex-col items-center bg-blue-100">
      {/* Tabs */}
      <Tabs
        aria-label="icon tabs example"
        className="w-screen pl-44 p-2 border-orange-400 mb-4"
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{
          "& .MuiTabs-indicator": {
            display: "none", // Hides the underline
          },
        }}
      >
        {/* First Tab (Subscription Plans) */}
        <Tooltip title="View Subscription" arrow>
          <Tab
            icon={
              <CurrencyExchangeIcon className="text-lg font-satoshi font-extrabold" />
            }
            aria-label="currency"
            className={`transition-all duration-300 rounded-md font-satoshi mr-2 font-extrabold ${
              activeTab === 0 ? "bg-[#027aae] text-white" : "bg-[#FAE1BC]"
            }`}
          />
        </Tooltip>

        {/* Second Tab (Chart) */}
        <Tooltip title="View Chart" arrow>
          <Tab
            icon={
              <LegendToggleIcon className="text-lg font-satoshi font-extrabold" />
            }
            aria-label="legend"
            className={`transition-all duration-300 rounded-md font-satoshi font-extrabold ${
              activeTab === 1 ? "bg-[#027aae] text-white" : "bg-[#FAE1BC]"
            }`}
          />
        </Tooltip>
      </Tabs>

      {/* Conditional Rendering */}
      <Grid container spacing={3} className="w-[100%] h-[78vh] overflow-y-auto pb-8 hide-scrollbar">
        {activeTab === 0 ? (
          // Show Subscription Plans when first tab is active
          subscriptionDetails?.map((ele) => {return(
            <>
            <SubscriptionCard {...ele} />
            </>
          )})
        ) : (
          // Show Chart when second tab is 
          <Grid container className="w-[100%] mt-5">
          <SubscriptionLineGraph />
          <SubscriptionBarChart data={transformedData} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default SuperAdminDashBoard;
